import {
	PORTFOLIO_CATEGORY_ORDER,
	type PortfolioCategoryId,
} from "web_myplann/Portfolio/Types/portfolioCategory";

export const togglePortfolioCategory = (
	categories: PortfolioCategoryId[],
	id: PortfolioCategoryId,
): PortfolioCategoryId[] => {
	const shown = categories.length === 0 ? PORTFOLIO_CATEGORY_ORDER : categories;
	const next = shown.includes(id)
		? shown.filter((category) => category !== id)
		: [...shown, id];

	return next.length === PORTFOLIO_CATEGORY_ORDER.length ? [] : next;
};
